import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { aggregationGetUser } from "actions/aggregation/actions";
import { Card } from "react-bootstrap";
import ReactTable from "react-table";
import moment from "moment";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";

const UserProfileAggregation = ({
                                  userId,
                                  aggregationGetUser,
                                  aggregatedUser
                                }) => {
  useEffect(() => {
    aggregationGetUser(userId);
  }, [aggregationGetUser, userId]);

  return (
    <div>
      {aggregatedUser.dataByCard ?
        <Card className="rounded-0">
          <Card.Header>
            Card Data
          </Card.Header>
          <Card.Body className="p-0">
            <ReactTable
              data={aggregatedUser.dataByCard
                .filter(item => item.wallet !== null)
                .map(item => item.wallet || {})}
              headerClassName="table-header"
              columns={[
                {
                  Header: "Id",
                  accessor: "id",
                  // eslint-disable-next-line react/display-name
                  Cell: ({ original }) => (
                    <Link to={`/users/${original.id}`}>
                      {original.id}
                    </Link>
                  )
                },
                {
                  Header: "Balance",
                  accessor: "balance",
                },
                {
                  Header: "Date",
                  accessor: "creationDate",
                  Cell: ({ original }) => moment(original.creationDate)
                    .format("HH:mm YYYY-MM-DD"),
                },
                {
                  Header: "Debt",
                  accessor: "debt",
                },
                {
                  Header: "Currency",
                  accessor: "currency",
                },
                {
                  Header: "Card",
                  accessor: "card",
                  // eslint-disable-next-line react/display-name
                  Cell: ({ original }) => (original.card ? (
                    <div>
                      {original.card.cardholder ? original.card.cardholder : "Holder Not Set"}<br/>
                      {original.card.cardMask ? original.card.cardMask : ""}({original.card.bankType ? original.card.bankType : ""})<br/>
                      {original.card.date ? moment(original.card.date)
                        .format("YYYY-MM-DD") : ""}
                    </div>
                  ) : ""),
                  style: {
                    whiteSpace: "unset"
                  }
                },
              ]}
              pageSize={20}
              resizable
              className="-striped -highlight table-header-padding"
              loading={false}
              filterable={false}
              defaultFilterMethod={filterCaseInsensitive}
              style={{
                height: 400
              }}
              manual={false}
            />
          </Card.Body>
        </Card>
        : null}
      {aggregatedUser.dataByDevice ?
        <Card className="rounded-0">
          <Card.Header>
            Device Data
          </Card.Header>
          <Card.Body className="p-0">
            <ReactTable
              data={aggregatedUser.dataByDevice
                .filter(item => item.wallet !== null)
                .map(item => item.wallet)}
              headerClassName="table-header"
              columns={[
                {
                  Header: "id",
                  accessor: "id",
                  // eslint-disable-next-line react/display-name
                  Cell: ({ original }) => (
                    <Link to={`/users/${original.id}`}>
                      {original.id}
                    </Link>
                  )
                },
                {
                  Header: "Balance",
                  accessor: "balance",
                },
                {
                  Header: "Date",
                  accessor: "creationDate",
                  Cell: ({ original }) => moment(original.creationDate)
                    .format("HH:mm YYYY-MM-DD"),
                },
                {
                  Header: "Debt",
                  accessor: "debt",
                },
                {
                  Header: "Currency",
                  accessor: "currency",
                },
                {
                  Header: "Card",
                  accessor: "card",
                  // eslint-disable-next-line react/display-name
                  Cell: ({ original }) => (original.card ? (
                    <div>
                      {original.card.cardholder ? original.card.cardholder : "Holder Not Set"}<br/>
                      {original.card.cardMask ? original.card.cardMask : ""}({original.card.bankType ? original.card.bankType : ""})<br/>
                      {original.card.date ? moment(original.card.date)
                        .format("YYYY-MM-DD") : ""}
                    </div>
                  ) : ""),
                  style: {
                    whiteSpace: "unset"
                  }
                },
              ]}
              pageSize={20}
              resizable
              className="-striped -highlight table-header-padding"
              loading={false}
              filterable={false}
              defaultFilterMethod={filterCaseInsensitive}
              style={{
                height: 400
              }}
              manual={false}
            />
          </Card.Body>
        </Card>
        : null}
    </div>
  );
};

UserProfileAggregation.propTypes = {
  userId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  aggregatedUser: state.aggregation.aggregatedUser
});

const mapStateToDispatch = dispatch => ({
  aggregationGetUser: bindActionCreators(aggregationGetUser, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(UserProfileAggregation);



// WEBPACK FOOTER //
// ./src/views/pages/users/user-profile-aggregation.js